<div fxLayout="row"
     fxLayoutAlign="space-between center"
     fxLayoutGap="30px"
     class="info-panel p-2 pe-3"
     [class]="panelClass"
     [class.info-panel-full-width]="fullWidth"
     [class.info-panel-disabled]="type === PanelType.DISABLED">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <mat-icon [ngClass]="[getPanelType().iconClass, iconClass].filter(Boolean)"
              fxFlexAlign="start">
      {{getPanelType().icon}}
    </mat-icon>
    <div fxLayout="column" fxLayoutAlign="center start" fxFlex>
      <ng-content></ng-content>
      <button
        mat-button
        color="primary"
        class="link-text btn-cursor"
        (click)="toggleExpanded()">
        {{isExpanded ? 'Read less' : 'Read more...'}}
      </button>
    </div>
  </div>
  <div fxLayout="column" fxLayoutAlign="end center" fxFlexAlign="center">
    <div fxLayout="row" *ngIf="showButtons" fxLayoutGap="5px">
      @for (button of buttonLabels; track button; let i = $index) {
        <button class="button-action" mat-flat-button
                [disabled]="buttonDisabled![i]"
                (click)="emit(i)">
          <div class="button-text">{{button!}}</div>
        </button>
      }
    </div>
  </div>
</div>
